module.exports = __webpack_public_path__ + "static/media/vortex-dark.521b9324.png";